"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _password = _interopRequireDefault(require("@/views/profile/password.vue"));

var _graphic = require("echarts/lib/util/graphic");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'AppMain',
  components: {
    password: _password.default
  },
  created: function created() {
    var _this = this;

    if (this.$store.state.user.isChangePwd) {
      this.$nextTick(function () {
        _this.$refs.password.showVisible(1);
      });
    }
  },
  computed: {
    cachedViews: function cachedViews() {
      // console.info(this.$store.state.tagsView.cachedViews)
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      //.replace(/\//g,'')
      //这里一定要全路径 否则不触发外拨切换客资
      return this.$route.fullPath;
    }
  }
};
exports.default = _default;